// extracted by mini-css-extract-plugin
export var logos = "fc-partners-module--logos--4203a";
export var root = "fc-partners-module--root--06900";
export var title = "fc-partners-module--title--406ef";